import { useState, useEffect } from 'react';
import { RotateCw, Sparkles } from 'lucide-react';
import MainLayout from '../../Layout/MainLayout';
import PageContainer from '../../components/layout/PageContainer';
import { useAppBookings } from '../../context/appBookings/AppBookingsContext';
import AppBookingsMetrics from './sections/MetricsOverview/AppBookingsMetrics';
import AppBookingsTable from './sections/BookingsTable/AppBookingsTable';
import BookingDetailsModal from './sections/BookingDetailsModal/BookingDetailsModal';

const AppBookingsPage = () => {
    const { bookings, loading, fetchBookings } = useAppBookings();
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [isNewBookingAnim, setIsNewBookingAnim] = useState(false);
    const [activeTabFilter, setActiveTabFilter] = useState('all');
    const [statusFilter, setStatusFilter] = useState('all');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        fetchBookings();
    }, [fetchBookings]);

    const handleRefresh = () => {
        fetchBookings();
    };

    return (
        <MainLayout activeTab="bookings">
            <PageContainer className="min-h-screen">
                {/* Page Header Bar */}
                <div className="mb-8 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
                    <div>
                        <h1 className="text-xl sm:text-2xl font-bold text-[#067978] tracking-tight">Trrip App Bookings</h1>
                        <p className="text-xs sm:text-sm text-slate-500 mt-1">Track all dining, activity, and shopping reservations made by your travellers through your branded trip deck.</p>
                    </div>
                    <div className="flex items-center gap-3">
                        <button
                            onClick={handleRefresh}
                            className="flex items-center gap-2 px-4 py-2 bg-white text-slate-600 hover:text-[#067978] rounded-full text-xs font-bold transition-all border border-slate-200 shadow-xs active:scale-95 cursor-pointer"
                            title="Refresh Data"
                            type="button"
                        >
                            <RotateCw size={14} className={loading ? "animate-spin text-[#067978]" : ""} />
                            <span>Refresh Data</span>
                        </button>
                        {isNewBookingAnim && (
                            <div className="flex items-center gap-2 px-4 py-2 bg-emerald-50 text-emerald-600 rounded-full text-[10px] font-black uppercase tracking-widest animate-bounce border border-emerald-200/60 shadow-xs">
                                <Sparkles size={14} />
                                New Booking Received!
                            </div>
                        )}
                    </div>
                </div>

                {/* Section 1: The 4 Metrics Overview Cards */}
                <AppBookingsMetrics bookings={bookings} />

                {/* Section 2: Bookings Table with Tabs, Filters & Pagination */}
                <AppBookingsTable
                    bookings={bookings}
                    loading={loading}
                    activeTabFilter={activeTabFilter}
                    setActiveTabFilter={setActiveTabFilter}
                    statusFilter={statusFilter}
                    setStatusFilter={setStatusFilter}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    itemsPerPage={itemsPerPage}
                    onSelectBooking={(booking) => setSelectedBooking(booking)}
                />
            </PageContainer>

            {/* Section 3: View Details Modal */}
            <BookingDetailsModal
                booking={selectedBooking}
                onClose={() => setSelectedBooking(null)}
            />
        </MainLayout>
    );
};

export default AppBookingsPage;
